// extracted by mini-css-extract-plugin
export default {"wrapper":"glossaryTerm_wrapper__tz38x","controls":"glossaryTerm_controls__4OWIb","explanation":"glossaryTerm_explanation__yqRR-"};